import { useAuth } from "@/Providers/Auth";
import { Button } from "@/shadcnComponents/ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shadcnComponents/ui/dialog";
import { Input } from "@/shadcnComponents/ui/input";
import { Label } from "@/shadcnComponents/ui/label";
import { Pencil } from "lucide-react";
import mixpanel from "mixpanel-browser";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
const host: string = import.meta.env.VITE_BACKEND_SERVER_URL;
import { useCookies } from "react-cookie";
import axios from "axios";

export const LoginForVerifyCollab = ({ navigateUrl }) => {
  const authState = useAuth();
  const [cookies, removeCookie] = useCookies();

  const [email, setEmail] = useState("");
  const [step, setStep] = useState(1);
  const [otp, setOtp] = useState("");
  const [type, setType] = useState("Login");

  useEffect(() => {
    mixpanel.track("Popup Login for Verify Collab Loaded");
  }, []);

  const BrandSignIn = async (email, navigateUrl) => {
    try {
      const response = await axios.post(`${host}/Brand/SignIn`, {
        email,
      });

      if (response.status === 200) {
        if (response.data.success) {
          toast.success("Login Successfull!, Verify Collab and Submit Rating.");
          localStorage.setItem("jwtToken", response.data.token);
          localStorage.setItem("UserType", "Brand");
          window.open(navigateUrl, "_self");
        } else {
          return { Error: response.data.error };
        }
      } else {
        return { Error: response.data.error };
      }
    } catch (error) {
      return { Error: error.response.data.error };
      // window.open("/", "_self");
    }
  };

  const BrandSignUp = async (email) => {
    try {
      const response = await axios.post(`${host}/Brand/SignUp`, { email });
      if (response.status === 200) {
        if (response.data.success) {
          authState.setLoggedBrand(response.data.email);
          return await BrandSignIn(email, navigateUrl);
        } else {
          // alert(response.data.error);
          return { Error: response.data.error };
        }
      } else {
        // alert(response.data.error);
        return { Error: response.data.error };
      }
    } catch (e) {
      console.log(e.response.data.error);
      return { Error: e.response.data.error };
    }
  };

  const verifyOTP = async (
    otp,
    email,
    type,
    navigateUrl,
    cookies,
    removeCookie
  ) => {
    if (otp?.length !== 4) {
      return { Error: "Please Enter a Proper Code" };
    } else {
      const code = cookies?.ccoondfe;
      if (!code) {
        return { Error: "OTP was valid for 2 minute, Please retry again" };
      } else {
        if (parseInt(otp) === parseInt(String(parseInt(code) / 562002))) {
          // alert("Verification was successfull");
          removeCookie("ccoondfe");
          if (type === "Login") {
            console.log("Login");
            return await BrandSignIn(email, navigateUrl);
          } else if (type === "SignUp") {
            console.log("SignUp");
            return await BrandSignUp(email);
          }
        } else {
          return { Error: "Invalid Otp" };
        }
      }
    }
  };

  const handleEmailSubmit = async () => {
    mixpanel.track("Login for Verify Collab Started");
    try {
      if (!email) {
        return toast.error("Please Enter Your Mail", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      const mailexist = await authState.getBrandByEmail(email);
      if (mailexist.success) {
        setType("Login");
      } else {
        setType("SignUp");
      }
      const result = await authState.sendingOTPFeature(email);
      if (result.success) {
        mixpanel.track("Requested Otp for Login");
        toast.info("Otp Sent Succesfully to your MailBox", {
          position: "top-center",
          autoClose: 2000,
        });
        setStep(2);
      } else {
        return toast.error(result.Error, {
          position: "top-center",
          autoClose: 2000,
        });
      }
    } catch (e) {
      return toast.error("Something went Wrong!", {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const handleResend = async (email) => {
    mixpanel.track("Resend Otp for Login");
    const result = await authState.sendingOTPFeature(email);
    if (result.success) {
      mixpanel.track("Requested Resend Otp");
      toast.info("Otp Sent Succesfully to your MailBox", {
        position: "top-center",
        autoClose: 2000,
      });
    } else {
      return toast.error(result.Error, {
        position: "top-center",
        autoClose: 2000,
      });
    }
  };

  const handleOTPSubmit = async () => {
    mixpanel.track("Otp Submitted, Verification for Login");
    try {
      if (!otp) {
        return toast.error("Enter a proper code", {
          position: "top-center",
          autoClose: 2000,
        });
      }
      const result = await verifyOTP(
        otp,
        email,
        type,
        navigateUrl,
        cookies,
        removeCookie
      );
      if (result?.Error) {
        return toast.error(result?.Error, {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        console.log(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      {step === 1 && (
        <EmailSignIn
          onSignIn={handleEmailSubmit}
          email={email}
          setEmail={setEmail}
        />
      )}
      {step === 2 && (
        <OtpVerification
          onVerify={handleOTPSubmit}
          email={email}
          setOtp={setOtp}
          setStep={setStep}
          otp={otp}
          resend={handleResend}
          type={type}
        />
      )}
    </>
  );
};

const EmailSignIn = ({ onSignIn, email, setEmail }) => {
  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle className="text-3xl font-bold">Verification!</DialogTitle>
        <DialogDescription className="text-gray-500 dark:text-gray-400">
          Please verify your email to continue
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 py-4">
        <div className="space-y-2">
          <Label htmlFor="email">Company Email</Label>
          <Input
            id="email"
            placeholder="Enter your official email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
      </div>
      <DialogFooter>
        <Button
          className="w-full"
          onClick={() => {
            mixpanel.track("Continue Button Clicked for Login");
            onSignIn();
          }}
        >
          Continue
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};

const OtpVerification = ({
  onVerify,
  setStep,
  email,
  setOtp,
  otp,
  resend,
  type,
}) => {
  return (
    <DialogContent className="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle className="text-3xl font-bold">Verification!</DialogTitle>
        <DialogDescription className="text-gray-500 dark:text-gray-400">
          Enter the OTP sent to your email to continue.
        </DialogDescription>
      </DialogHeader>
      <div className="grid gap-4 py-4">
        <div className="space-y-2 relative">
          <Label htmlFor="email">Company Email</Label>
          <Input
            id="email"
            placeholder="Enter your official email"
            type="email"
            value={email}
            disabled
            className="pr-10"
          />
          <Button
            variant="ghost"
            size="icon"
            onClick={() => {
              mixpanel.track(`Edit Email Button Clicked for ${type}`);
              setStep(1);
            }}
            className="absolute right-0 top-11 transform -translate-y-1/2"
          >
            <Pencil size={14} />
          </Button>
        </div>
        <div className="space-y-2 relative">
          <Label htmlFor="otp">OTP</Label>
          <Input
            id="otp"
            placeholder="Enter OTP"
            type="otp"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="pr-20"
          />
          <Button
            variant="link"
            onClick={() => {
              mixpanel.track(`Resend Button Clicked for ${type}`);
              resend(email);
            }}
            className="absolute right-0 top-11 transform -translate-y-1/2"
          >
            Resend
          </Button>
        </div>
      </div>

      <DialogFooter>
        <Button
          className="w-full"
          onClick={() => {
            mixpanel.track(`Verify Button Clicked for ${type}`);
            onVerify();
          }}
        >
          Verify
        </Button>
      </DialogFooter>
    </DialogContent>
  );
};
